// middleware/routing.global.ts
export default defineNuxtRouteMiddleware( ( to ) => {
	const { activeRoute } = utilityStores();

	if ( to.matched.length === 0 || to.path.includes( "/rsvp" ) ) {
		return navigateTo( "/" );
	}

	activeRoute.value = to.path;
} );